// Mock data for Move to Cornwall website

export const heroData = {
  title: "Discover Life on the St. Lawrence",
  subtitle: "Welcome to Cornwall, Ontario - Where Natural Beauty Meets Opportunity",
  description: "Experience riverside living, outdoor adventures, and a thriving community in one of Eastern Ontario's hidden gems."
};

export const benefitsData = [
  {
    id: 1,
    title: "Affordable Living",
    description: "Housing costs 40% lower than Toronto and Ottawa, with average home prices around $377,000",
    icon: "home",
    data: "Based on 2024 MLS data"
  },
  {
    id: 2,
    title: "Natural Paradise",
    description: "45km of waterfront trails along the St. Lawrence River, perfect for biking, walking, and water sports",
    icon: "trees",
    data: "Cornwall Tourism 2024"
  },
  {
    id: 3,
    title: "Strategic Location",
    description: "1 hour to Montreal, 1 hour to Ottawa - perfect for commuters and businesses",
    icon: "map-pin",
    data: "Google Maps distance"
  },
  {
    id: 4,
    title: "Growing Economy",
    description: "$150M in commercial investments in 2023, with tech and manufacturing sectors expanding",
    icon: "trending-up",
    data: "Cornwall Economic Development"
  },
  {
    id: 5,
    title: "Quality Healthcare",
    description: "Cornwall Community Hospital serves 165,000 people with comprehensive medical services",
    icon: "heart-pulse",
    data: "CCH Annual Report 2024"
  },
  {
    id: 6,
    title: "Family-Friendly",
    description: "Excellent schools, low crime rates, and abundant recreational facilities for all ages",
    icon: "users",
    data: "Statistics Canada 2024"
  }
];

export const businessBenefits = [
  {
    id: 1,
    title: "Lower Operating Costs",
    description: "Commercial lease rates 50-60% lower than major cities, reducing overhead significantly",
    savings: "50-60% savings"
  },
  {
    id: 2,
    title: "Skilled Workforce",
    description: "Access to bilingual talent pool with technical training from St. Lawrence College",
    savings: "Bilingual advantage"
  },
  {
    id: 3,
    title: "Tax Incentives",
    description: "Municipal and provincial programs supporting business growth and job creation",
    savings: "Up to 25% credits"
  },
  {
    id: 4,
    title: "Infrastructure",
    description: "Direct access to Highway 401, rail connections, and proximity to US border",
    savings: "Logistics advantage"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "The St. Lawrence River: Cornwall's Greatest Asset",
    excerpt: "Explore how 45 kilometers of pristine waterfront is transforming Cornwall into an outdoor recreation hub.",
    date: "2024-08-15",
    category: "Lifestyle",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800"
  },
  {
    id: 2,
    title: "Why Tech Companies Are Choosing Cornwall",
    excerpt: "A data-driven look at the growing technology sector and what's attracting innovators to the region.",
    date: "2024-08-10",
    category: "Business",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800"
  },
  {
    id: 3,
    title: "Biking Cornwall: A Trail Guide for Every Rider",
    excerpt: "Complete guide to Cornwall's extensive trail network, from scenic riverside paths to challenging routes.",
    date: "2024-08-05",
    category: "Recreation",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1541625602330-2277a4c46182?w=800"
  },
  {
    id: 4,
    title: "Housing Market Analysis: Cornwall vs Major Cities",
    excerpt: "Real estate data showing how Cornwall offers unmatched value for homebuyers and investors.",
    date: "2024-07-28",
    category: "Real Estate",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800"
  }
];

export const defaultAdPackages = [
  {
    id: 1,
    name: "Banner Starter",
    price: 199,
    duration: "1 month",
    features: [
      "728x90 leaderboard placement",
      "Homepage rotation",
      "Basic analytics dashboard"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Featured Partner",
    price: 499,
    duration: "3 months",
    features: [
      "Multiple banner sizes (728x90, 300x250)",
      "Homepage + blog placement",
      "1 sponsored blog post",
      "Advanced analytics",
      "Social media mentions"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Premium Sponsor",
    price: 1299,
    duration: "6 months",
    features: [
      "All banner placements site-wide",
      "Priority positioning",
      "3 sponsored blog posts",
      "Quiz sponsorship",
      "Newsletter feature (2x)",
      "Dedicated landing page",
      "Full analytics suite"
    ],
    popular: false
  }
];

export const quizData = {
  title: "How Well Do You Know Cornwall?",
  questions: [
    {
      id: 1,
      question: "What river does Cornwall sit on?",
      options: ["Ottawa River", "St. Lawrence River", "Rideau River", "Grand River"],
      correct: 1
    },
    {
      id: 2,
      question: "How far is Cornwall from Montreal?",
      options: ["30 minutes", "1 hour", "2 hours", "3 hours"],
      correct: 1
    },
    {
      id: 3,
      question: "What is the approximate length of Cornwall's waterfront trail system?",
      options: ["15 km", "25 km", "45 km", "60 km"],
      correct: 2
    },
    {
      id: 4,
      question: "Which college is located in Cornwall?",
      options: ["Algonquin College", "St. Lawrence College", "Georgian College", "Seneca College"],
      correct: 1
    },
    {
      id: 5,
      question: "What major highway runs through Cornwall?",
      options: ["Highway 400", "Highway 417", "Highway 401", "Highway 7"],
      correct: 2
    }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Young Professional",
    location: "Moved from Toronto in 2023",
    quote: "I bought a beautiful 3-bedroom house for less than my Toronto condo. The quality of life here is incredible - I bike to work along the river every day!",
    rating: 5
  },
  {
    id: 2,
    name: "David Chen",
    role: "Business Owner",
    location: "Relocated company in 2022",
    quote: "Moving our tech startup to Cornwall was the best decision. Lower costs, great talent from SLC, and we're still close to our Montreal and Ottawa clients.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Thompson",
    role: "Retiree",
    location: "Settled in Cornwall 2021",
    quote: "After decades in the city, Cornwall offers the perfect balance - peaceful, beautiful nature, but with all the amenities we need. Plus, family can visit easily from Ottawa!",
    rating: 5
  }
];

export const stats = [
  { label: "Population", value: "47,000+", icon: "users" },
  { label: "Avg. Home Price", value: "$377K", icon: "home" },
  { label: "Waterfront Trail", value: "45 km", icon: "bike" },
  { label: "To Montreal", value: "1 hour", icon: "clock" }
];